import { Container } from "react-bootstrap";

function Bodytitle() {
    return (
        <Container className="d-flex justify-content-between mt-3">
            <div>
                <p>Explore from <span className="fw-bold">30+ Courses</span> </p>
            </div>
            <div className="fw-bold">
                <p>Recommended
                    |
                    Popular
                    |
                    Recently Added</p>
            </div>
        </Container>
    );
}

export default Bodytitle;